import { FC } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import SSOLoginButton from "src/pages/login/ssoLogin";

import { ExparelLogo } from "../../assets";
import { PublicHeader } from "../../constants/headerLinks";
import { HeaderElementType } from "../../types";

const GuestHeader: FC = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <nav className="navbar navbar-expand-lg p-2 login-nav">
      <div className="container">
        <Link className="navbar-brand" to="/users/sign_in"><img src={ExparelLogo} alt="Site logo" /></Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#hubHeader">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse justify-content-end" id="hubHeader">
          <ul className="navbar-nav align-items-start align-items-lg-center">
            <li className="nav-item">
              <a href="https://www.exparelpro.com/Enrollment-Form.pdf" target="_blank" rel="noopener noreferrer"
                 className="nav-link">
                Request Form
              </a>
            </li>
            {PublicHeader.map((headerLink, index) => (
                <li
                    className={`nav-item ${
                        headerLink.actionType === HeaderElementType.DRPODOWN
                            ? "dropdown"
                            : ""
                    }`}
                    key={index}
                >
                  {headerLink.actionType === HeaderElementType.ROUTE ? (
                      <Link
                          className="nav-link"
                          aria-current="page"
                          to={headerLink.redirectLink}
                      >
                        {headerLink.title}
                      </Link>
                  ) : null}
                  {headerLink.actionType === HeaderElementType.BUTTON ? (
                      <button
                          className="btn btn-warning rounded-pill"
                          onClick={() => {
                            navigate(headerLink.redirectLink);
                          }}
                      >
                        {headerLink.title}
                      </button>
                  ) : null}
                  {headerLink.actionType === HeaderElementType.LINK ? (
                      <a
                          className="nav-link"
                          href={headerLink.redirectLink}
                          target="_blank"
                          rel="noreferrer"
                      >
                        {headerLink.title}
                      </a>
                  ) : null}
                </li>
            ))}
            <li className="nav-item"><SSOLoginButton/></li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default GuestHeader;
